import { useState } from "react";

export const PRESETS = [
  ["today", "Today"], ["yesterday", "Yesterday"], ["week", "This Week"], ["last_week", "Last Week"],
  ["month", "This Month"], ["year", "This Year"], ["all", "All Time"], ["custom", "Custom"],
];

export const PeriodFilter = ({ value, onChange }) => {
  const [from, setFrom] = useState(value.from_day || "");
  const [to, setTo] = useState(value.to_day || "");
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="period-filter">
      {PRESETS.map(([k, l]) => (
        <button key={k} data-testid={`period-${k}`} onClick={() => onChange(k === "custom" ? { preset: "custom", from_day: from, to_day: to } : { preset: k })}
          className={`px-3 py-1.5 rounded-full text-xs border transition-colors ${value.preset === k ? "border-[#00F0FF] text-[#00F0FF] bg-[#00F0FF]/10" : "border-white/10 text-gray-400 hover:border-white/30"}`}>
          {l}
        </button>
      ))}
      {value.preset === "custom" && (
        <div className="flex items-center gap-2 ml-2">
          <input data-testid="period-from" type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="input-dark !w-40 !py-1.5 text-xs" />
          <span className="text-gray-500 text-xs">to</span>
          <input data-testid="period-to" type="date" value={to} onChange={(e) => setTo(e.target.value)} className="input-dark !w-40 !py-1.5 text-xs" />
          <button data-testid="period-apply" disabled={!from || !to} onClick={() => onChange({ preset: "custom", from_day: from, to_day: to })} className="btn-primary px-3 py-1.5 text-xs disabled:opacity-40">Apply</button>
        </div>
      )}
    </div>
  );
};
